/* eslint-disable no-template-curly-in-string */
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import SnackbarUtils from 'utils/SnackbarUtils';
import {
  changeModalProps,
  closeModal,
  openModal,
} from '../../../store/modules/ModalActions';
import { getMergedClassNames } from '../../../utils/HTMLUtils';
import { getUniqueKey } from '../../../utils/NumberUtils';
import ProgressModal from '../../ProgressModal/ProgressModal';
import styles from './CustomUploadEntePublico.scss';
const rootClassName = styles.rootClassName;

const INITIAL_STATE = {
  modalKey: null,
  uploading: false,
  fileName: null,
  percent: 0,
  formId: null,
  inputName: null,
};

class CustomUploadEntePublico extends Component {
  constructor(props) {
    super(props);
    this.state = {
      ...INITIAL_STATE,
      formId:
        typeof this.props.formId === 'string'
          ? this.props.formId
          : getUniqueKey(),
      inputName: getUniqueKey(),
    };
  }

  getFileName = () => {
    return this.state.fileName || '';
  };

  getPercent = () => {
    return Math.round(this.state.percent * 100);
  };

  onProgress = (percent) => {
    if (typeof this.props.uploadActionProgressCallback === 'function') {
      this.props.uploadActionProgressCallback(percent);
    }
    this.setState(
      {
        percent: percent,
      },
      () => {
        if (this.feedbackOnModalIsEnabled() && this.state.modalKey) {
          this.props.changeModalProps(this.state.modalKey, {
            percent: this.state.percent,
          });
        }
      }
    );
  };

  onSuccess = (resp) => {
    new Promise((resolve) => {
      SnackbarUtils.enqueueSnackbar({
        message: this.props.languageValues.uploadFileSuccess
          .split('${1}')
          .join(this.getFileName()),
        options: {
          variant: 'success',
        },
      });
      this.setState(
        {
          percent: 0,
          fileName: null,
          uploading: false,
        },
        () => {
          if (this.feedbackOnModalIsEnabled() && this.state.modalKey) {
            this.props.closeModal(this.state.modalKey);
            this.setState({
              modalKey: null,
            });
            resolve();
          } else {
            resolve();
          }
        }
      );
    }).then(() => {
      if (typeof this.props.uploadActionSuccessCallback === 'function') {
        this.props.uploadActionSuccessCallback(resp);
      }
    });
  };

  onError = (error) => {
    new Promise((resolve) => {
      SnackbarUtils.enqueueSnackbar({
        message:
          error.response.statusText ||
          this.props.languageValues.uploadFileError
            .split('${1}')
            .join(this.getFileName()),
        options: {
          variant: 'error',
        },
      });
      this.setState(
        {
          percent: 0,
          fileName: null,
          uploading: false,
        },
        () => {
          if (this.feedbackOnModalIsEnabled() && this.state.modalKey) {
            this.props.closeModal(this.state.modalKey);
            this.setState(
              {
                modalKey: null,
              },
              resolve
            );
          } else {
            resolve();
          }
        }
      );
    }).then(() => {
      if (typeof this.props.uploadActionErrorCallback === 'function') {
        this.props.uploadActionErrorCallback(error);
      }
    });
  };

  getDisabled = () => {
    if (
      typeof this.props.buttonComponentProps === 'object' &&
      this.props.buttonComponentProps.disabled
    ) {
      return true;
    }
    return this.state.uploading ? true : this.props.disabled;
  };

  getLabel = () => {
    const label = this.props.label || this.props.languageValues.uploadLabel;
    const uploadingLabel = (
      this.props.uploadingLabel || this.props.languageValues.uploadingLabel
    )
      .split('${1}')
      .join(String(this.getPercent()) + '%');
    return this.state.uploading ? uploadingLabel : label;
  };

  resetInputElement = () => {
    const element = this.getInputFileElement();
    if (element) {
      element.value = null;
      this.setState({
        inputName: getUniqueKey(),
      });
    }
  };

  fileIsValid = (file) => {
    return typeof this.props.fileIsValid === 'function'
      ? this.props.fileIsValid(file)
      : {
          status: true,
        };
  };

  startUpload = (file) => {
    return new Promise((resolve) => {
      const data = {
        ...this.props.uploadActionData,
        file: file,
      };
      this.props.uploadAction(
        data,
        this.onProgress,
        this.onSuccess,
        this.onError
      );
      resolve();
    });
  };

  toUpload = (files) => {
    return new Promise((resolve, reject) => {
      const file = files[0];
      const fileValidation = this.fileIsValid(file);
      if (!fileValidation.status) {
        SnackbarUtils.enqueueSnackbar({
          /* eslint-disable-next-line */
          message: fileValidation.error,
          options: {
            variant: 'error',
          },
        });
        if (typeof this.props.onChange === 'function') {
          this.props.onChange(null);
        }
        reject();
      }
      if (file && fileValidation.status) {
        if (typeof this.props.uploadAction === 'function') {
          this.setState(
            {
              fileName: file.name,
              uploading: true,
              percent: 0,
            },
            () => {
              if (this.feedbackOnModalIsEnabled()) {
                const modalKey = this.props.openModal(ProgressModal, {
                  title: this.props.feedbackOnModalTitle,
                  percent: this.state.percent,
                }).payload.key;
                this.setState(
                  {
                    modalKey,
                  },
                  () => {
                    this.startUpload(file).then(resolve);
                  }
                );
              } else {
                this.startUpload(file).then(resolve);
              }
            }
          );
        } else {
          if (typeof this.props.onChange === 'function') {
            this.props.onChange(file);
          }
          reject();
        }
      } else {
        reject();
      }
    });
  };

  getInputFileElement = () => {
    return document.querySelector('input[name=' + this.state.inputName + ']');
  };

  toBrowseFile = () => {
    const inputFile = this.getInputFileElement();
    inputFile.click();
    if (document.activeElement) {
      document.activeElement.blur();
    }
  };

  getButtonComponent = () => {
    if (this.props.buttonComponent) {
      const $component = this.props.buttonComponent;
      let componentProps = {
        ...(this.props.buttonComponentProps || {}),
      };
      componentProps.disabled = this.getDisabled();
      componentProps.className = getMergedClassNames([
        rootClassName,
        componentProps.className || '',
        this.props.className || '',
      ]);
      if (!this.props.hideLabel) {
        componentProps.label = this.getLabel();
      }
      componentProps.onClick = this.toBrowseFile;
      /* eslint-disable-next-line */
      return <$component {...componentProps} />;
    }
  };

  feedbackOnModalIsEnabled = () => {
    return this.props.feedbackOnModal &&
      typeof this.props.feedbackOnModalTitle === 'string'
      ? true
      : false;
  };

  getFormElement = (children) => {
    if (typeof this.props.formId === 'string') {
      return children;
    }
    return (
      <form className={rootClassName + '-form'} id={this.state.formId}>
        {children}
      </form>
    );
  };

  onChangeInput = (event) => {
    this.toUpload(event.target.files).then(
      this.resetInputElement,
      this.resetInputElement
    );
  };

  render() {
    const { idAditivo } = this.props.contratosEntePublico.contratoEditing;
    const inputId = 'upload-extrato-ente-publico';
    const inputAditivoId = idAditivo
      ? `upload-extrato-ente-publico-${idAditivo}`
      : null;

    return (
      <>
        {this.getButtonComponent()}
        {typeof this.state.inputName === 'string' && (
          <>
            <input
              id={inputId}
              name={this.state.inputName}
              type='file'
              title=''
              className={`${rootClassName}-input`}
              onChange={this.onChangeInput}
              alt=''
              style={{ display: 'none' }}
            />
            {inputAditivoId && (
              <input
                id={inputAditivoId}
                name={this.state.inputName}
                type='file'
                title=''
                className={`${rootClassName}-input`}
                onChange={this.onChangeInput}
                alt=''
                style={{ display: 'none' }}
              />
            )}
          </>
        )}
      </>
    );
  }
}

CustomUploadEntePublico.propTypes = {
  formId: PropTypes.string,
  id: PropTypes.string,
  className: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  uploadingLabel: PropTypes.string,
  onChange: PropTypes.func,
  hideLabel: PropTypes.bool,
  buttonComponent: PropTypes.func.isRequired,
  buttonComponentProps: PropTypes.object,
  disabled: PropTypes.bool,
  fileIsValid: PropTypes.func,
  uploadAction: PropTypes.func,
  uploadActionData: PropTypes.object,
  uploadActionProgressCallback: PropTypes.func,
  uploadActionSuccessCallback: PropTypes.func,
  uploadActionErrorCallback: PropTypes.func,
  feedbackOnModal: PropTypes.bool,
  feedbackOnModalTitle: PropTypes.string,
};

const mapStateToProps = (state) => ({
  contratosEntePublico: state.contratosEntePublico,
  languageValues: state.languages.languageValues,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      openModal,
      closeModal,
      changeModalProps,
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CustomUploadEntePublico);
